import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Card, CardBody } from "reactstrap";

class Statistics extends React.Component {
  constructor(props) {
    super(props);
    this.renderColumns = this.renderColumns.bind(this);
  }
  renderColumns(icon, title, subtitle) {
    let columns = null;
    let firstColumn = (
      <Col xs={12} md={3}>
        <div>
          {this.props.showIcon && icon}
          {title}
          {!this.props.isSubtitleObject && subtitle}
          {this.props.subtitleObject}
          {this.props.subtitleObject2}
        </div>
      </Col>
    );
    columns = this.props.columns.map((column, key) => {
      return (
        <Col key={key} xs={12} md={3}>
          {column}
        </Col>
      );
    });

    columns = (
      <div>
        {firstColumn}
        {columns}
      </div>
    );

    return columns;
  }
  render() {
    const icon = (
      <div
        className={
          "icon icon-" +
          this.props.iconState +
          (this.props.horizontal ? " icon-circle" : "")
        }
      >
        <i className={"now-ui-icons " + this.props.icon} />
      </div>
    );
    const title = <h3 className="info-title">{this.props.title}</h3>;
    const subtitle = <h6 className="stats-title">{this.props.subtitle}</h6>;
    return (
      <div
        className={
          "statistics" + (this.props.horizontal ? " statistics-horizontal" : "")
        }
      >
        <div
          className={"info" + (this.props.horizontal ? " info-horizontal" : "")}
        >
          {!this.props.multipleColumn ? (
            this.props.horizontal && this.props.rtl ? (
              <Row>
                <Col xs={7} className="text-left">
                  {title}
                  {subtitle}
                </Col>
                <Col xs={5}>{icon}</Col>
              </Row>
            ) : this.props.horizontal ? (
              <Row>
                <Col xs={5}>{icon}</Col>
                <Col xs={7} className="text-right">
                  {title}
                  {subtitle}
                </Col>
              </Row>
            ) : (
              <div>
                {this.props.showIcon && icon}
                {title}
                {!this.props.isSubtitleObject && subtitle}
                {this.props.subtitleObject}
                {this.props.subtitleObject2}
              </div>
            )
          ) : (
            <Row>
              <Col xs={12} md={12}>
                <Card className="card-stats card-raised">
                  <CardBody>
                    <Row>
                      {this.renderColumns(icon, title, subtitle)}
                    </Row>
                  </CardBody>
                </Card>                    
              </Col>
            </Row>
          )}
        </div>
      </div>
    );
  }
}

Statistics.defaultProps = {
  iconState: "default"
};

Statistics.propTypes = {
  iconState: PropTypes.oneOf([
    "primary",
    "success",
    "info",
    "danger",
    "warning",
    "default"
  ]),
  icon: PropTypes.string,
  title: PropTypes.node,
  subtitle: PropTypes.node,
  horizontal: PropTypes.bool,
  rtl: PropTypes.bool,
  showIcon: PropTypes.bool,
  isSubtitleObject: PropTypes.bool,
  isSubtitleObject2: PropTypes.bool,
  subtitleObject: PropTypes.node,
  subtitleObject2: PropTypes.node,
  multipleColumn: PropTypes.bool,
  columns: PropTypes.array
};

export default Statistics;



// WEBPACK FOOTER //
// ./src/components/Statistics/Statistics.jsx